@if (allowLink()) {
  <app-link-column [label]="requestId()" [routerLink]="routerLink()" [newTab]="newTab()"></app-link-column>
} @else {
  {{ requestId() }}
}
